import type { SelectOption } from '@property.com.au/ui-kit';

export const mapSelectOptionWithIntValueToSelectOption = ({
  label,
  value,
}: {
  label?: string | null;
  value: number;
}): SelectOption => {
  return { label: label ?? '', value: String(value) };
};
